import { dateFormatedToDB } from "../../functions";
import { PackagesReportModel } from "../../models/reports";

export default class PackagesReportController {
  constructor() {
    this.name = "reports-packages";
    this.tableName = `${this.name}-table`;
    this.paginationName = `${this.name}-pagination`;

    this.MPackagesReport = PackagesReportModel();
    this.init();
  }

  init = async () => { this.findPackagesReport(); };

  findPackagesReport = async () => { await this.MPackagesReport.findPackagesReport(); };

  setPage = (page) => { this.MPackagesReport.setPage(page); };

  setFilter = (filterData) => {
    const filter = { ...filterData };
    if ("dateFrom" in filter) filter.dateFrom = dateFormatedToDB(filter.dateFrom);
    if ("dateTo" in filter) filter.dateTo = dateFormatedToDB(filter.dateTo);
    this.MPackagesReport.setFilter(filter);
  };

  clearFilter = async () => {
    this.MPackagesReport.setFilter({ status: "*", cpf: "", search: "" });
    await this.filterPackages();
  };

  /** KPI como atalho de filtro: clicar aplica, clicar de novo limpa. */
  toggleFilter = async (patch) => {
    const current = this.MPackagesReport.currentFilter();
    const alreadyApplied = Object.entries(patch).every(([key, value]) => current[key] === value);
    const next = Object.keys(patch).reduce(
      (acc, key) => ({ ...acc, [key]: alreadyApplied ? "*" : patch[key] }),
      {}
    );
    this.MPackagesReport.setFilter(next);
    await this.filterPackages();
  };

  handleSortColumn = async (sortBy) => {
    const current = this.MPackagesReport.currentSort();
    const sortOrder = current.sortBy === sortBy && current.sortOrder === "asc" ? "desc" : "asc";
    this.MPackagesReport.setSort({ sortBy, sortOrder });
    await this.filterPackages();
  };

  filterPackages = async (e) => {
    if (e) e.preventDefault();
    await this.MPackagesReport.filterPackagesReport();
  };

  reportExport = () => { this.MPackagesReport.export(); };
}
